import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { contactsApi } from "../../api/endpoints";

export function useContacts(params?: { search?: string; type?: string; read?: boolean }) {
  return useQuery({
    queryKey: ["contacts", params],
    queryFn: () => contactsApi.list(params).then((r) => r.data),
    // Aramada her tuşta iskelete düşmemek için önceki sonucu koru.
    placeholderData: keepPreviousData,
  });
}

export function useContactStats() {
  return useQuery({
    queryKey: ["contacts", "stats"],
    queryFn: () => contactsApi.stats().then((r) => r.data),
  });
}

export function useMarkContactRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => contactsApi.markRead(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["contacts"] }),
  });
}

export function useDeleteContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => contactsApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["contacts"] }),
  });
}
